<script>
export let label
export let value
</script>


<div class="flex-row flex justify-between text-gray-500 font-light">
    <div class="text-sm">{label}</div>
    <div class="text-sm text-gray-700 font-medium">{value}</div>
</div>